import listify from 'listify';
import { WorkspaceQueue } from '../../panels/workspace-queue';

const displayEntityType = {
    CAD_AGENCY_EVENT: 'Event',
    UNIT: 'Unit',
    HOSPITAL: 'Hospital',
} as const;

const displayQueueClass = {
    POLICE: 'Police',
    FIRE: 'Fire',
    MEDICAL: 'EMS',
};

export function getQueueTitle(
    entityType: WorkspaceQueue['dataEntityType'],
    queueClasses: WorkspaceQueue['queueClasses'],
    assignmentStatus: WorkspaceQueue['assignmentStatus'],
    eventQueueType?: WorkspaceQueue['eventQueue']
): string {
    if (eventQueueType === 'TELEPHONE_RESPONSE_UNIT') {
        return 'TRU Events';
    }
    if (entityType === 'SCHEDULED_AGENCY_EVENT') {
        return 'Scheduled Events';
    }
    if (entityType === 'BOLO') {
        return 'BOLOs';
    }
    return [
        listify(
            queueClasses
                .map((qc) => displayQueueClass[qc])
                .sort()
                // want the order to always be Police, Fire, EMS
                .reverse()
        ),
        assignmentStatus === true ? 'Assigned' : assignmentStatus === false ? 'Unassigned' : '',
        `${displayEntityType[entityType as keyof typeof displayEntityType]}s`,
    ]
        .filter((s) => s)
        .join(' ');
}
